/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Manage_Payment_AppleInputs */

const en_plan_manage_payment_apple = /** @type {(inputs: Plan_Manage_Payment_AppleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can manage your payment method in the `)
};

const es_plan_manage_payment_apple = /** @type {(inputs: Plan_Manage_Payment_AppleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes administrar tu método de pago en la `)
};

/**
* | output |
* | --- |
* | "You can manage your payment method in the" |
*
* @param {Plan_Manage_Payment_AppleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_manage_payment_apple = /** @type {((inputs?: Plan_Manage_Payment_AppleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Manage_Payment_AppleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_manage_payment_apple(inputs)
	return en_plan_manage_payment_apple(inputs)
});